import type {
  AccountSettings,
  ConnectGoogleAccountInput,
  UpdateAccountAvatarInput,
  UpdateAccountInput,
  UpdateAccountPasswordInput,
} from "schemas/generated/bedrock";
import type { RequestFn } from "./request";

export function createAccountClient({ request }: { request: RequestFn }) {
  return {
    get: () => {
      return request<AccountSettings>({
        method: "GET",
        path: "/api/v1/account",
      });
    },
    update: (input: UpdateAccountInput) => {
      return request<AccountSettings>({
        method: "PATCH",
        path: "/api/v1/account",
        body: input,
      });
    },
    updatePassword: (input: UpdateAccountPasswordInput) => {
      return request<AccountSettings>({
        method: "POST",
        path: "/api/v1/account/password",
        body: input,
      });
    },
    connectGoogle: (input: ConnectGoogleAccountInput) => {
      return request<AccountSettings>({
        method: "POST",
        path: "/api/v1/account/google",
        body: input,
      });
    },
    avatar: {
      update: (input: UpdateAccountAvatarInput) => {
        return request<AccountSettings>({
          method: "PUT",
          path: "/api/v1/account/avatar",
          body: input,
        });
      },
      delete: () => {
        return request<AccountSettings>({
          method: "DELETE",
          path: "/api/v1/account/avatar",
        });
      },
    },
  };
}
